import React from 'react'
import { TStrapiV4YoutubeWidget } from '../../common-types'
import { Strapi4CTAByType } from '../../atoms-components/cta-by-type/cta-by-type'
import Title from '../../common-components/Title'
import YoutubeCard from './youtube-card'

import Carousel from '@/stories/components/Common/Carousel/Carousel'
import PrimaryCard from '@/components/Common/PrimaryCard'

type TProps = TStrapiV4YoutubeWidget

export const StrapiV4YoutubeWidget = (props: TProps) => {
  const { title, cards } = props

  return (
    <div className="bg-brand-tertiary-grey mb-8 py-8 xl:mb-12 xl:py-12">
      <div className="herolike-wrapper ">
        <PrimaryCard
          containerClass="mb-5"
          childClass="p-5 bg-brand-grey-background"
        >
          <Title
            className="mb-5 text-center font-semibold lg:mb-8"
            fontSize="size-54"
          >
            {title}
          </Title>
          <Carousel dots showArrows stopAutoPlay>
            <div className="flex flex-row gap-4">
              {cards?.map((card, index) => (
                <YoutubeCard key={index} card={card} />
              ))}
            </div>
          </Carousel>
          <Strapi4CTAByType
            type="primary"
            url="https://www.youtube.com/@INDmoney"
            addClassNames="mx-auto mt-10"
          >
            Checkout INDmoney Youtube
          </Strapi4CTAByType>
        </PrimaryCard>
      </div>
    </div>
  )
}
